import {
  FACE_BACK,
  FACE_FRONT,
  FACE_LEFT,
  FACE_RIGHT,
  FACE_TOP,
  isSecondaryDefect
} from '../../../services/live-interface/verallia-interface-service';

const facesByFrontDirection = {
  right: {
    top: FACE_RIGHT,
    right: FACE_FRONT,
    bottom: FACE_LEFT,
    left: FACE_BACK
  },
  down: {
    top: FACE_BACK,
    right: FACE_RIGHT,
    bottom: FACE_FRONT,
    left: FACE_LEFT
  },
  left: {
    top: FACE_LEFT,
    right: FACE_BACK,
    bottom: FACE_RIGHT,
    left: FACE_FRONT
  },
  up: {
    top: FACE_FRONT,
    right: FACE_LEFT,
    bottom: FACE_BACK,
    left: FACE_RIGHT
  }
};

export const VeralliaPallet = ({ palletId, defaults = [], palletStyle, bounds, frontDirection, activeDefault }) => {
  const borderSize = 12;
  const centerGap = 6;
  const minSide = Math.min(palletStyle.width, palletStyle.height);
  const topSize = Math.max(minSide - (borderSize + centerGap) * 2, 0);
  const faces = facesByFrontDirection[frontDirection] ?? facesByFrontDirection.right;

  const getFaceStatus = (face) => {
    const faceDefaults = defaults.filter((defaultData) => defaultData.face != null && Number(defaultData.face) === face);
    const hasImportantDefect = faceDefaults.some((defaultData) => !isSecondaryDefect(defaultData.type));
    const hasSecondaryDefect = faceDefaults.length > 0 && !hasImportantDefect;
    const isActive = faceDefaults.length > 0 && activeDefault?.palletId === palletId && activeDefault.face != null && Number(activeDefault.face) === face;

    return {
      background: hasImportantDefect ? 'bg-red-600' : hasSecondaryDefect ? 'bg-amber-400' : 'bg-green-600',
      textColor: hasSecondaryDefect ? 'text-black' : 'text-white',
      zIndex: isActive ? 30 : faceDefaults.length > 0 ? 20 : 10,
      isActive
    };
  };

  const top = getFaceStatus(faces.top);
  const bottom = getFaceStatus(faces.bottom);
  const left = getFaceStatus(faces.left);
  const right = getFaceStatus(faces.right);
  const center = getFaceStatus(FACE_TOP);

  const renderFace = (status, className, style) => (
    <div className={`absolute overflow-hidden ${className} ${status.isActive ? 'bg-neutral-400' : status.background}`} style={{ ...style, zIndex: status.zIndex }}>
      {status.isActive && <div className={`absolute inset-0 ${status.background}`} style={{ animation: 'verallia-pallet-blink 1s step-end infinite' }} />}
    </div>
  );

  return (
    <div
      className="pointer-events-none absolute z-10"
      style={{
        left: palletStyle.left - bounds.left,
        top: palletStyle.top - bounds.top,
        width: palletStyle.width,
        height: palletStyle.height
      }}
    >
      {renderFace(top, 'left-0 right-0 top-0 rounded-t', { height: borderSize })}
      {renderFace(bottom, 'bottom-0 left-0 right-0 rounded-b', { height: borderSize })}
      {renderFace(left, 'bottom-0 left-0 top-0 rounded-l', { width: borderSize })}
      {renderFace(right, 'bottom-0 right-0 top-0 rounded-r', { width: borderSize })}
      {renderFace(center, 'rounded', { left: '50%', top: '50%', width: topSize, height: topSize, transform: 'translate(-50%, -50%)' })}

      <div className={`absolute z-40 flex items-center justify-center whitespace-nowrap rounded text-center text-3xl font-extrabold leading-none ${center.textColor}`} style={{ left: '50%', top: '50%', width: topSize, height: topSize, transform: 'translate(-50%, -50%)' }}>
        <span className="drop-shadow-lg">{palletId}</span>
      </div>
    </div>
  );
};